import './commonAssets';

import '../common/modules/stock/collections/tabbed-stock-collections.less';
import '../common/stylesheets/modules/collections/collection-browse.less';
import '../global/components/storyblocks-collection-browse.less';
import '../global/tools/mixins.less';
import '../graphicstock/components/markup-mixins.less';


import AppLoader from '../react/AppLoader/AppLoader';
import NPSModalLoaderContainer from '../react/NPSModalLoader/NPSModalLoaderContainer';
import ReactToastifyContainer from '../react/ReactToastify/containers/ReactToastifyContainer';
import PopUpsContainer from '../react/PopUps/PopUpsContainer';
import EntTrialBanner from "../react/Trials/EntTrialBanner";
import NavApps from "../react/app/NavApps";

AppLoader.load({
  routes: [],
  auxApps: {
    ...NavApps,
    'pop-up-container': PopUpsContainer, // FIXME: causes missing matching <div> in <section>
    'nps-modal': NPSModalLoaderContainer,
    'react-toastify-container': ReactToastifyContainer, // FIXME: causes missing matching <div> in <section>
  },
  propBasedApps: {
    'entTrialBanner': EntTrialBanner
  },
});
